/**
 * Targets for the header links carried over from the Scala app
 * (`src/webapp/app/views/main.scala.html`).
 *
 * Both manuals are the PDFs of the Scala app (`src/webapp/public/d`), copied
 * unchanged into `public/download` so they ship with the SPA. The imprint and
 * the privacy notice are not listed here: they open as dialogs, see
 * `components/Footer`.
 */
export const EXTERNAL_LINKS = {
  USER_MANUAL: '/download/benutzerhandbuch.pdf',
  ADMIN_MANUAL: '/download/adminhandbuch.pdf',
} as const;

/** Support contact shown in the footer, see `components/Footer/HelpdeskDialog.tsx`. */
export const HELPDESK = {
  EMAIL: 'sparkasse@sparkassen-finanzportal.de',
  PHONE: '030 24 636-720',
} as const;
